import axios from 'axios';

const state = {
	isActive: false
}

const mutations = {
	POPUP_TOGGLE(state,payload){
		state.isActive=!state.isActive
	}
}

const actions = {
	popupToggle({commit}){
		commit('POPUP_TOGGLE')
	}
}

const getters = {

}

const popupModule = {
	state,
	mutations,
	actions,
	getters
}

export default popupModule;



// WEBPACK FOOTER //
// ./src/store/modules/popup/index.js